import { get, post, put } from './fetch'

export const getProfile = () => {
  return get(`/api/seller/profile`);
}

export const updateProfile = (profile) => {
  return put(`/api/seller/profile`, profile);
}

export const getSellerDetails = (sellerId) => {
  return get(`/api/sellers/${sellerId}/detail`, true);
}

export const saveSellerAdditionalInfo = (sellerID, alternatePhones, additionalInfo) => {
  return post(`/api/manager/sellers/${sellerID}/additional-info/save`, { additionalInfo: additionalInfo, alternatePhones: alternatePhones}, true);
}

export const saveSellerDetail = (sellerID, bodyObject) => {
  return post(`/api/manager/sellers/${sellerID}/details/save`, { ...bodyObject }, true);
}

export const getSellerList = (phrase) => {
  return post(`/api/manager/sellers/search`, { "searchTerm": phrase.trim() }, true);
}

export const getPaymentIntent = (sellerID, paymentDetails) => {
  return post(`/api/manager/seller/${sellerID}/getPaymentIntent`, paymentDetails, true);
}

export const addSellerSubscription = (sellerID, data) => {
  return post(`/api/manager/seller/${sellerID}/add/subscription`, data, false);
}

export const getSellerPaymentMethods = (sellerID, data) => {
  return get(`/api/manager/seller/${sellerID}/payment-methods`, data, false);
}

export const getDiscount = (promo, sellerID) => {
  return get(`/api/manager/seller/${sellerID}/promo/${promo}`)
}

export const saveFailedPaymentsNotes = (sellerID, failedPaymentNotes) => {
  return post(`/api/manager/sellers/${sellerID}/payments/failed/notes/save`, { failedPaymentNotes: failedPaymentNotes }, true);
}

export const updateSellerEmail = (sellerID, email) => {
  return post(`/api/manager/sellers/${sellerID}/email/update`, {  email }, true);
}

export const sendTestEmailToTrialSeller = (sellerID) => {
  return post(`/api/manager/sellers/${sellerID}/email/test/send`, {  sellerID }, true);
}

export const saveSellerInfo = (sellerID, sellerObject , alternatePhones) => {
  return post(`/api/manager/sellers/${sellerID}/info/save`, { sellerObject : {...sellerObject} , alternatePhones}, true);
}